export const protectRoute = ({
	token = null,
	type = 0,
	isAllyRoute = false,
	router,
}) => {
	const allyTypes = [100, 110, 111];
	if (!token || (!allyTypes.includes(type) && isAllyRoute))
		router.push("/iniciar-sesion");
};